import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';
import stringHelper from '../../utils/stringHelper';

type NumberFieldTypes = "uInteger"
type NumberFieldProps = {
    /**
     * The type of value to manipulate.
     * @default 'uInteger'
     */
    type: NumberFieldTypes,

    /**
     * The value of the input element.
     */
    value: number | null,

    /**
     * Callback fired when the value is changed.
     * @param value The new value.
     * @returns 
     */
    onChange: (value: number | null) => void,
} & Omit<TextFieldProps, "type" | "value" | "onChange">

/**
 * Composant permettant la saisie de valeurs numériques.
 * Pour le bon fonctionnement de celui-ci, veuillez renseigner les propriétés `type`, `value` et `onChange`
 */
class NumberField extends React.Component<NumberFieldProps> {

    /**
     * Fonction permettant convertir la valeur saisie par le client en une valeur exploitable
     * @param valueFiled Valeur saisie par le client
     */
    callbackOnChange(valueFiled: string) {
        const { value, type, onChange } = this.props;

        let newValue = value;

        switch (type) {
            case 'uInteger':
                {
                    let isUnsignedInteger = stringHelper.isUnsignedInteger(valueFiled)
                    if (isUnsignedInteger)
                        newValue = parseInt(valueFiled);
                    else if (valueFiled === "") // Correspond à une saisie effacé de tous caractères
                        newValue = null;
                    break;
                }
        
            default:
                break;
        }

        onChange(newValue);
    }

    render() {

        const { value, type, onChange, ...otherProps } = this.props;

        return (
            <TextField
                value={value ?? ""}
                onChange={(event) => this.callbackOnChange(event.target.value)}
                {...otherProps}
            />
        );
    }
}

export default NumberField;